module.exports = __webpack_public_path__ + "media/images/home/main/aa/backup/6-3ec6a62cb7533800380b7668f7fcc231.png";